import React, {Component} from "react";
import {Field, reduxForm} from "redux-form";
import {MenuItem} from 'material-ui';
import moment from "moment";
import {TextField,SelectField} from "redux-form-material-ui";
import axios from 'axios';
import toastr from 'toastr';
import {hashHistory} from "react-router";

const renderField = (props) => (
  <input  {...props} />
);
const Comments = (() => {
  return (
    <TextField
      hintText="Enter comments if any"
      multiLine={true}
      rows={2}
      rowsMax={4}/>
  );
});

const validate = values => {
  const errors = {};
  const requiredFields = ['title', 'subTitle', 'description','category'];
  requiredFields.forEach(field => {

    if (values[field] == null) {
      errors[field] = 'Required'
    }
  });
  if(values['category']=='Quikr_Inspector')
  {
    if(values['feedbackLink']==null)
      errors['feedbackLink']='Required';
  }
  return errors;
}

class Form extends Component {
  constructor() {
    super();
    this.state = {startDate: moment(),file: null,inspector: true,disabled: true}
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  componentDidMount() {
    // on TextField
  }

  render() {
    const style = {
      "fontSize": "20px"
    };
    const stylePaper = {
      height: "75%",
      width: "75%",
      margin: 20,
      textAlign: 'left',
      display: 'inline-block',
    };
    const {handleSubmit, pristine, reset, submitting} = this.props;
     return (
      <form onSubmit={handleSubmit(submitData => {
        let text="Are you sure you want to create this announcement"
        if(submitData.category=='Quikr_Inspector')
        {text="Are you sure you want to create this Inspection?";}
        let x = confirm(text);
        if(x)
        {let time = new Date().getTime();
          let imageLinks=[];
          if(this.state.file!=null) {
            for(var i=0;i<this.state.file.length; i++){
              let data = new FormData();
              data.append('picture', this.state.file[i], time +"_"+i+ ".jpg");
              imageLinks.push( time +"_"+i+ ".jpg");
               let xhr = new XMLHttpRequest();
              xhr.open('POST', 'https://hrms.quikrcorp.com/app/upload', true);
              //xhr.setRequestHeader("Content-Type","multipart/form-data");
              // Set up a handler for when the request finishes.
              xhr.onload = function () {
                if (xhr.status === 200) {
                  console.log("hey");

                  // File(s) uploaded.
                } else {
                  alert('An error occurred!');
                }
              }.bind(this);
              xhr.send(data);
            }
          }


          axios.post(process.env.REQ_URL + "/chatter/saveAnnouncement",{data: {
            category: submitData.category,
            title: submitData.title,
            feedbackLink: submitData.feedbackLink,
            imageLink: JSON.stringify(imageLinks),
            subTitle: submitData.subTitle,
            description: submitData.description,
          }},{withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=>{
            toastr.success("Saved");
            hashHistory.push("/1/announcements");
          });
          console.log(this.state.file);

        }


      })}>
        <div className="col-xs-12" style={{
          borderBottomStyle: 'solid',
          borderColor: '#428BCA',
          borderWidth: '1px',
          borderTopStyle: 'solid',
          borderTopColor: 'rgb(92, 184, 92)'
        }}>
          <div className="col-xs-10">
            <Field name="category"  component={SelectField} floatingLabelText="Select Announcement Type">
              <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
              <MenuItem onTouchTap={(e) => {
                this.setState({inspector: false,disabled: false})
              }} value="Quikr_Inspector" primaryText="Quikr Inspectr"/>
              <MenuItem
                onTouchTap={(e) => {
                  this.setState({inspector: true,disabled: false})
                }}

                value="Public" primaryText="Public"/>
            </Field>
            </div>
          <div className="col-xs-10">
            <Field name="title" disabled={this.state.disabled} fullWidth={true} component={TextField} hintText={!this.state.inspector?"Provide a catchy heading for your experiment":"Provide a heading for the announcement"} floatingLabelText="Enter Title" ref="emailId"
                   withRef/>
            <br/>
            <Field name="subTitle" disabled={this.state.disabled} fullWidth={true} component={TextField} hintText={!this.state.inspector?"Give a short summary that best describes your experiment":"Short description"} floatingLabelText="Enter one line summary"/>

          </div>
          <label></label>
          <div className="col-xs-10">
          <Field name="description" disabled={this.state.disabled} component={TextField} hintText={!this.state.inspector?"Provide all necessary details (what's changed ; what's the objective ; how to access it, etc.)":"Enter description"}
                 multiLine={true}
                 rows={3}
                 fullWidth={true}
                 floatingLabelText="Enter description"/>
            </div>
          <div className="col-xs-10">

            <br/>
            {!this.state.inspector?"Upload mocks or screenshots":"Upload Images"}
            <input
              onChange={(event)=> {
                let files= event.target.files;
                let filesState=[];
                for(var i=0;i<files.length; i++)
                {
                  var reader = new FileReader();
                  files[i]=reader.readAsDataURL(files[i])
                  debugger;
                  console.log(files[i]);
                  filesState.push(files[i]);
                }
                this.setState({file: filesState})
              }}
              type="file" multiple={true} accept=".jpg"/>

            <Field name="feedbackLink"
                   fullWidth={true} disabled={this.state.inspector} component={TextField} hintText="Link format (http://<website url> or https://<website url>)" floatingLabelText="Feedback Link"/>
            <br/><br/>
          </div>
          <div  className="col-xs-10">
            <button className="btn btn-default btn-block" type="submit" disabled={pristine || submitting}>Save</button>
            <br/>
          </div>

        </div>





        </form>

    )
  }
}

export default reduxForm({
  form: 'announcementCreate',
  validate

})(Form)



/** WEBPACK FOOTER **
 ** ./src/feature/announcements/components/AnnouncementCreateForm.js
 **/